// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectInstrumentGroupMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_INSTRUMENT_TYPE);
        this.LanguageAliases = null;
        this.ExtendedFields = {};
        this.InstrumentType = null;
        this.superTypeId = 0;
        this.typeId = 0;
        this.typeName = null;
    }
    get SuperTypeId() {
        return this.superTypeId;
    }
    set SuperTypeId(val) {
        this.superTypeId = val;
    }
    get TypeId() {
        return this.typeId;
    }
    set TypeId(val) {
        this.typeId = val;
    }
    get TypeName() {
        return this.typeName;
    }
    set TypeName(val) {
        this.typeName = val;
    }
}
